



















import HeaderLayout from '@/components/Header.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {Switch} from 'element-ui'
import {namespace} from 'vuex-class'
import {initState} from '@/store/modules/noti'
import {BizPropertyPayload, LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
const noti = namespace('noti')
const layout = namespace('layout')
const gtm = namespace('gtm')

interface NotiList {
  title: string
  value: boolean
  name: string
}

@Component({
  components: {HeaderLayout, MainLayout, [Switch.name]: Switch},
})
export default class NotiPage extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: number

  @noti.State('isTaxNotiAllowed') isTaxNotiAllowed
  @noti.State('isInvoiceNotiAllowed') isInvoiceNotiAllowed
  @noti.Action('getNoti') getNoti
  @noti.Action('updateNoti') updateNoti
  @layout.Mutation('updateError') updateError
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void
  @gtm.Action('setBizProperty') setBizProperty: (payload: BizPropertyPayload) => void

  loading: boolean = true

  get notiList(): NotiList[] {
    return Object.keys(initState).map((itemName) => ({
      title: this.changeToTitle(itemName),
      value: this[itemName],
      name: itemName,
    }))
  }

  changeToTitle(itemName): string {
    const {ts} = this
    const notiNameDict = {
      isTaxNotiAllowed: ts('tax'),
      isInvoiceNotiAllowed: ts('purchase-invoice')
    }
    return notiNameDict[itemName] || ''
  }

  created() {
    this.loadNoti()
  }

  loadNoti() {
    const {getNoti, updateError, ts} = this
    getNoti()
      .catch((error) => {
        updateError({
          id: 'get-noti',
          message: `${ts('notification')}을 불러오는데 ${ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {
        this.loading = false
      })
  }

  onClickBackward() {
    this.$router.push({name: 'setting'}).catch((err) => err)
  }

  onChangeSwitch(value, name) {
    const {updateNoti, updateError, ts} = this
    this.loading = true
    updateNoti({[name]: value})
      .then(() => {
        this.sendAmplitude(value, name)
      })
      .catch((error) => {
        updateError({
          id: 'update-noti',
          message: `${ts('notification')}을 ${ts('setting')}하는데 ${ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {
        this.loading = false
      })
  }

  sendAmplitude(value, name) {
    this.logEventWithGroups({
      eventType: 'change_setting_noti',
      eventProperties: {
        'noti_type': name,
        value,
      }
    })
    this.setBizProperty({
      event: 'setBizProperty',
      bizProperty: {
        'tax_notification': this.isTaxNotiAllowed ? 'on' : 'off',
        'invoice_notification': this.isInvoiceNotiAllowed ? 'on' : 'off'
      }
    })
  }
}
